// Curated country list for registration (Italia first). Values = display labels (stored as-is).
export const COUNTRIES = [
  "Italia",
  "San Marino",
  "Svizzera",
  "Francia",
  "Germania",
  "Spagna",
  "Regno Unito",
  "Austria",
  "Belgio",
  "Paesi Bassi",
  "Portogallo",
  "Grecia",
  "Irlanda",
  "Croazia",
  "Slovenia",
  "Polonia",
  "Romania",
  "Albania",
  "Ucraina",
  "Russia",
  "Stati Uniti",
  "Canada",
  "Brasile",
  "Argentina",
  "Messico",
  "Marocco",
  "Tunisia",
  "Egitto",
  "Nigeria",
  "Senegal",
  "Cina",
  "India",
  "Giappone",
  "Filippine",
  "Pakistan",
  "Bangladesh",
  "Turchia",
  "Australia",
  "Altro",
];

// Birth years from (currentYear - 13) down to 1925.
export const BIRTH_YEARS = (() => {
  const cur = new Date().getFullYear();
  const arr = [];
  for (let y = cur - 13; y >= 1925; y--) arr.push(y);
  return arr;
})();

export const GENDER_OPTIONS = [
  { value: "uomo", label: "Uomo" },
  { value: "donna", label: "Donna" },
  { value: "altro", label: "Altro" },
  { value: "na", label: "Preferisco non dirlo" },
];
